<template>
    <div class="share-button" ref="shareMenu" @click.stop>
        <button @click="toggleShareMenu" class="share-icon">
            <Share/>
        </button>
        <div v-if="showShareMenu" class="share-menu">
            <div class="div-cross">
                Partager l'annonce
                <button class="share-icon" @click="closeShareMenu">
                    <Cross/>
                </button>
            </div>

            <ul>
                <li class="cursor-pointer">
                    <a @click="copyToClipboard()">
                        <Copy/> Copier le lien
                    </a>
                </li>
                <li>
                    <a @click="email(vehicle)">
                        <Mail/> Email
                    </a>
                </li>
                <li>
                    <a :href="facebookShareUrl" target="_blank">
                        <Facebook/> Facebook
                    </a>
                </li>
                <li>
                    <a :href="whatsappLink" target="_blank">
                        <Whatsapp/> Whatsapp
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
  import Whatsapp from '../Icons/Whatsapp.vue';
  import Facebook from '../Icons/Facebook.vue';
  import Cross from '../Icons/Cross.vue';
  import Mail from '../Icons/Mail.vue';
  import Copy from '../Icons/Copy.vue';
  import Share from '../Icons/Share.vue'

  export default {
    components: {
      Whatsapp,
      Facebook,
      Cross,
      Mail,
      Copy,
      Share,
    },
    props: {
      ad: Object,
    },
    data() {
        return {
            showShareMenu: false, // Tracks if the sharing menu is visible
        }
    },
    methods: {
        toggleShareMenu() {
            this.showShareMenu = !this.showShareMenu;
        },
        closeShareMenu() {
            this.showShareMenu = false;
        },
        handleClickOutside(event) {
            const menu = this.$refs.shareMenu;
            if (menu && !menu.contains(event.target)) {
                this.closeShareMenu();
            }
        },
        copyToClipboard() {
            navigator.clipboard.writeText(this.ad.full_url).then(() => {
                alert('Lien copié dans le presse-papiers !');
            });
        },
        email() {
            const mailtoLink = `mailto:?subject=Une annonce pour vous sur Ewigo&body=${encodeURIComponent(this.customMessage(true))}`;
            window.location.href = mailtoLink;
        },
        customMessage(emoticone) {
            return `${emoticone ? '👋' : ''} Hello !

Vous êtes à la recherche d'une nouvelle voiture ?
Découvrez cette offre qui pourrait bien vous plaire :

${emoticone ? '🚗' : ''} ${this.ad?.make || ''} ${this.ad?.model || ''}
${emoticone ? '📍' : ''} ${this.ad?.kms || ''} km
${emoticone ? '💶' : ''} ${this.ad?.price || ''} €

${emoticone ? '🔗' : ''} Consultez l'annonce ici : ${this.ad.full_url}

Vous voulez voir plus de véhicules similaires ?
${emoticone ? '👀' : ''} Découvrez toutes les ${this.ad?.make || ''} disponibles ici : ${this.brandUrl || ''}

À bientôt chez Ewigo !`;
        },
    },
    mounted () {
        document.addEventListener("click", this.handleClickOutside);
    },
    beforeDestroy() {
        document.removeEventListener("click", this.handleClickOutside);
    },
    computed: {
        brandUrl() {
            return `https://wvw.ewigo.com/achat?filter[type]=&filter[marque]=${this.ad.make}&filter[modele]=&filter[energie]=&filter[vitesse]=&filter[kms_max]=120000&filter[price_max]=100000&filter[reliable]=false&sort=-id&page=1&kw=`;
        },
        facebookShareUrl() {
            return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.ad.full_url)}`;
        },
        whatsappLink() {
            return `https://wa.me/?text=${encodeURIComponent(this.customMessage(false))}`;
        },
    }
  }
</script>

<style>
.share-menu {
    position: absolute;
    top: 100%;
    right: 0;
    background: white;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    border-radius: 14px;
    z-index: 10;
    width: 225px;
    padding-top: 12px;
}

.div-cross {
    display: flex;
    justify-content: space-between;
    padding: 10px 10px 10px 20px;
    font-size: 16px;
    align-items: center;
}

.share-menu ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.share-menu li {
    cursor: pointer;
    display: flex !important;
    align-items: center;
    font-size: 14px;

    a {
        display: flex !important;
        text-decoration: none;
        padding: 10px;
        padding-left: 20px;
        width: 100%;
        height: 100%;
        color: black;
        align-items: center;
        gap: 10px;
        position: relative !important;
    }
}



.share-menu li:hover {
    background: #f0f0f0;
    svg {
        fill: #F18402 !important;
    }
}

.share-icon {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 16px;
    display: flex;
    align-items: center;
}
</style>
